const IMPORTABLE_FIELDS = [
  {
    key: 'title',
    required: true,
    aliases: ['title', 'titel', 'naam', 'name', 'product', 'productnaam'],
  },
  { key: 'description', aliases: ['description', 'beschrijving', 'omschrijving'] },
  { key: 'url', aliases: ['url', 'link', 'product_url', 'producturl'] },
  {
    key: 'image_url',
    aliases: [
      'image_url',
      'imageurl',
      'image',
      'afbeelding',
      'afbeelding_url',
      'foto',
      'image_link',
    ],
  },
  {
    key: 'price',
    aliases: ['price', 'prijs', 'prijs_excl', 'prijs_excl_btw', 'price_excl_vat', 'verkoopprijs'],
  },
  { key: 'sale_price', aliases: ['sale_price', 'saleprice', 'actieprijs', 'aanbiedingsprijs'] },
  {
    key: 'base_sku',
    aliases: [
      'sku',
      'base_sku',
      'artikelnummer',
      'artikelcode',
      'artikel',
      'sku_code',
      'code',
      'productcode',
    ],
  },
  { key: 'label', aliases: ['label', 'tag'] },
  {
    key: 'production_notes',
    aliases: ['production_notes', 'productienotities', 'productie_notities', 'productie'],
  },
  {
    key: 'proposal_notes',
    aliases: ['proposal_notes', 'offertenotities', 'offerte_notities', 'offerte'],
  },
  {
    key: 'standard_hours',
    aliases: ['standard_hours', 'normuren', 'norm_uren', 'montageuren'],
  },
  { key: 'unit', aliases: ['unit', 'eenheid', 'maateenheid', 'unit_of_measure'] },
  { key: 'usps', aliases: ['usps', 'usp', 'voordelen', 'usps_list'] },
  {
    key: 'categories',
    aliases: [
      'categories',
      'categorie',
      'categorieen',
      'categorieën',
      'category',
      'categorie_naam',
    ],
  },
  { key: 'vat_rate', aliases: ['vat_rate', 'btw', 'btw_tarief', 'vat', 'btwpercentage'] },
  { key: 'target_margin_pct', aliases: ['target_margin_pct', 'marge', 'doelmarge', 'marge_pct'] },
  { key: 'min_margin_pct', aliases: ['min_margin_pct', 'min_marge', 'minimummarge'] },
  {
    key: 'prices_include_vat',
    aliases: [
      'prices_include_vat',
      'prijs_incl_btw',
      'incl_btw',
      'prijzen_incl_btw',
      'btw_inbegrepen',
    ],
  },
  { key: 'position', aliases: ['position', 'positie', 'volgorde'] },
];

function normalizeHeader(value) {
  return String(value || '')
    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_|_$/g, '');
}

export function suggestProductImportMapping(headers) {
  const mapping = {};
  const usedFields = new Set();

  for (const header of headers) {
    const normalized = normalizeHeader(header);
    const match = IMPORTABLE_FIELDS.find(
      (field) =>
        !usedFields.has(field.key) &&
        field.aliases.some((alias) => normalizeHeader(alias) === normalized)
    );
    if (match) {
      mapping[header] = match.key;
      usedFields.add(match.key);
    } else {
      mapping[header] = '';
    }
  }

  return mapping;
}

export function mappingHasTitle(mapping) {
  return Object.values(mapping || {}).includes('title');
}

export function duplicateMappedFields(mapping) {
  const counts = {};
  Object.values(mapping || {}).forEach((field) => {
    if (!field) return;
    counts[field] = (counts[field] || 0) + 1;
  });
  return Object.keys(counts).filter((field) => counts[field] > 1);
}

export function sampleValues(rows, header, limit = 3) {
  return (rows || [])
    .map((row) => String(row?.[header] || '').trim())
    .filter(Boolean)
    .slice(0, limit);
}

export function buildTemplateCsv() {
  const header = [
    'Naam',
    'SKU',
    'Beschrijving',
    'Prijs',
    'Actieprijs',
    'Categorieën',
    'USPs',
    'Afbeelding URL',
    'Label',
  ];
  const example = [
    'Zipscreen Comfort',
    'ZS-100',
    'Zipscreen met ritsgeleiding',
    '1250,00',
    '',
    'Screens',
    'Windvast | Onderhoudsarm',
    '',
    '',
  ];
  return `${header.join(';')}\n${example.join(';')}\n`;
}

export { IMPORTABLE_FIELDS };
